var NmaInterventionType, arrayOf, boolean, docShape, docTypes, documentId, explanationType, initial, mapOf, nmaQuestionDocShape, optional, shape, string, _ref;

arrayOf = require('lib/db_docs/field_types/array_of');

documentId = require('lib/db_docs/field_types/document_id');

docShape = require('lib/db_docs/field_types/doc_shape');

docTypes = require('lib/db_docs/doc_types');

initial = require('lib/db_docs/field_types/type_decorators').initial;

mapOf = require('lib/db_docs/field_types/map_of');

NmaInterventionType = require('lib/db_docs/field_types/nma_intervention_type');

shape = require('lib/db_docs/field_types/shape');

_ref = require('lib/db_docs/field_types/built_in_types'), string = _ref.string, boolean = _ref.boolean;

optional = shape.typeDecorators.optional;

explanationType = shape({
  id: string,
  text: string
});

nmaQuestionDocShape = docShape({
  author: optional(string),
  docType: initial(docTypes.NMA_QUESTION)(string),
  interventions: initial([])(arrayOf(NmaInterventionType)),
  thresholdOptions: optional(string),
  outcomes: initial([])(arrayOf(documentId)),
  population: optional(string),
  question: string,
  setting: optional(string),
  commonComparator: optional(string),
  explanations: optional(mapOf(explanationType)),
  vizConfig: optional(shape({
    comparatorTableMode: optional(string),
    interventionComparisonPairs: optional(arrayOf(arrayOf(string))),
    transposed: optional(boolean),
    showThresholds: optional(boolean),
    showSymbolsInsteadOfLettersAsFootnote: optional(boolean)
  }))
});

module.exports = nmaQuestionDocShape;
